/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// Axios
import { getUserDataFromLocalStorage } from "../../core/utils";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import "./UnderwritingSummaryPdfPage.css";
// eslint-disable-next-line no-unused-vars
import { Document, Page } from "react-pdf";
import { Dropdown, DropdownButton } from "react-bootstrap";
import apiRoutes from "../../api/apiRoutes";
import Navbar from "../../core/components/NavBar";
import UserContext from "../../core/UserContext";

const FlexiUnderwritingSummaryPdf = () => {
  const params = useParams();
  const userDataStorage = getUserDataFromLocalStorage();
  const { userData, setUserData } = useContext(UserContext);
  const axiosPrivate = useAxiosPrivate(userDataStorage);
  const quotationId = params.quotationId;
  const [fileURL, setFileURL] = useState();
  const [loading, setLoading] = useState(false);
  const [hasFinancialUnderwriting, setHasFinancialUnderwriting] =
    useState(false);
  const [updatingQuotationStatus, setUpdatingQuotationStatus] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const documentRef = useRef();

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  const navigate = useNavigate();

  const getQuotationSummary = async () => {
    setLoading(true);
    setFileURL(null);
    const url =
      process.env.REACT_APP_API_URL +
      apiRoutes.generateUnderwritingSummaryPdf +
      quotationId;

    axiosPrivate
      .get(url, {
        responseType: "blob",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.download = "some.pdf";

        const fileUrl = URL.createObjectURL(blob);

        setFileURL(fileUrl);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const updateQuotationStatus = async (payload) => {
    setUpdatingQuotationStatus(true);
    const url =
      process.env.REACT_APP_API_URL +
      `/quotation/worker/status-update/${quotationId}`;

    try {
      payload = { ...payload, userId: params.userId };
      const { data } = await axiosPrivate.patch(url, payload);

      setUpdatingQuotationStatus(false);

      if (!data.success) {
        // console.log(
        //   data.message
        //     ? data.message
        //     : "Quotation update was unsuccessful, please try again"
        // );
      } else {
        // navigate(`/review/${quotation.id}`);
      }
    } catch (error) {
      setUpdatingQuotationStatus(false);
      // console.log(error);
    }
  };

  const getQuotationDetails = async () => {
    const url = process.env.REACT_APP_API_URL + `/quotation/${quotationId}`;

    try {
      const response = await axiosPrivate.get(url);
      if (response.data.success === true) {
        const quotation = response.data.data;
        quotation.quotationFormData = JSON.parse(quotation.quotationFormData);

        const tenMillionRuleBoolean = quotation?.livesTenMillionData
          ? JSON.parse(quotation?.livesTenMillionData)
          : null;
        const eightMillionRuleBoolean = quotation?.livesEightMillionData
          ? JSON.parse(quotation?.livesEightMillionData)
          : null;

        console.log({
          tenMillionRuleBoolean,
          eightMillionRuleBoolean,
          quotation,
        });

        if (
          (tenMillionRuleBoolean?.mainLifeAmountExceededTenMillion ||
            tenMillionRuleBoolean?.jointLifeAmountExceededTenMillion) &&
          (eightMillionRuleBoolean?.mainLifeAmountExceededEightMillion ||
            eightMillionRuleBoolean?.jointLifeAmountExceededEightMillion)
        ) {
          setHasFinancialUnderwriting(true);
        } else {
          setHasFinancialUnderwriting(false);
        }
      }
    } catch (error) {
      throw new Error(error);
    }
  };

  useEffect(() => {
    getQuotationDetails();
    getQuotationSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Navbar
        name={
          userData
            ? `${userData?.data?.firstname} ${userData?.data?.lastname}`
            : ""
        }
      />
      <div
        className="mt-4 d-flex justify-content-between align-items-center p-4 px-5 text-white ila-bg"
        style={{ borderRadius: 2 }}
      >
        {hasFinancialUnderwriting ? (
          <DropdownButton
            id="dropdown-basic-button"
            title="Medical Underwriting Summary"
          >
            <Dropdown.Item
              href={`${process.env.REACT_APP_BASENAME}/underwriting-summary/${params.userId}/${quotationId}`}
            >
              Medical Underwriting Summary
            </Dropdown.Item>
            <Dropdown.Item
              href={`${process.env.REACT_APP_BASENAME}/financial-underwriting-summary/${params.userId}/${quotationId}`}
            >
              Financial Underwriting Summary
            </Dropdown.Item>
          </DropdownButton>
        ) : (
          <h4 className="mb-0">Medical Underwriting Summary</h4>
        )}

        <div className="d-flex flex-wrap">
          <a
            style={{ cursor: "pointer !important" }}
            className="btn ila-accent-btn login_btn text-white me-3 mt-3"
            onClick={() => {
              navigate(`/underwriting/${params.quotationId}/main-life`);
            }}
          >
            Back to Medical Underwriting
          </a>
          <a
            style={{ cursor: "pointer !important" }}
            className="btn ila-accent-btn login_btn text-white mt-3"
            onClick={() => {
              updateQuotationStatus({ status: "kyc" }).then((res) => {
                navigate(
                  `/client-kyc/${params.userId}/${params.quotationId}/main`
                );
              });
            }}
          >
            {updatingQuotationStatus && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            Proceed
          </a>
        </div>
      </div>

      {fileURL && (
        <div
          style={{
            maxHeight: "600px",
            width: "100%",
            textAlign: "center",
            marginBottom: 100,
          }}
        >
          <Document
            ref={documentRef}
            style={{ width: "100%" }}
            file={fileURL}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                scale={1.5}
              />
            ))}
          </Document>
        </div>
      )}
      {loading && (
        <div className="d-flex justify-content-center flex-column mt-5 align-items-center">
          <span
            className="spinner-border  me-2"
            role="status"
            aria-hidden="true"
          ></span>
          <div>Please wait ...</div>
        </div>
      )}
    </>
  );
};

export default FlexiUnderwritingSummaryPdf;
